
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.766 15.417h-.267V7l.149.087a.233.233 0 00.32-.085.234.234 0 00-.085-.32l-7.765-4.51a.234.234 0 00-.236 0L.117 6.682a.234.234 0 10.235.405L.501 7v8.417H.234a.234.234 0 100 .469h15.532a.234.234 0 000-.469zm-3.491 0h-8.55v-.784h8.55v.784zm0-2.505h-7.03a.234.234 0 000 .469h7.03v.784h-8.55v-.784h.517a.234.234 0 000-.469h-.517v-.784h8.55v.784zm0-2.505h-.517a.234.234 0 000 .469h.517v.784h-8.55v-.784h7.03a.234.234 0 100-.469h-7.03v-.784h8.55v.784zm2.755 5.01h-2.287V9.39a.234.234 0 00-.234-.234H3.491a.234.234 0 00-.234.234v6.028H.97V6.728L8 2.646l7.03 4.082v8.69z","fill":"#6C6C6C"}})])
          )
        }
      }
    